// src/router/index.ts
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import { isSignedIn, isCurrentUserSuperUser, saveIntendedPath } from '@/assets/common'

const HomePage = () => import('../pages/HomePage.vue')
const LogsPage = () => import('../pages/LogsPage.vue')
const AboutPage = () => import('../pages/AboutPage.vue')
const UsersPage = () => import('../pages/UsersPage.vue')
const SignInPage = () => import('../pages/SignInPage.vue')
const ContactPage = () => import('../pages/ContactPage.vue')
const ProfilePage = () => import('../pages/ProfilePage.vue')
const AddBookPage = () => import('../pages/AddBookPage.vue')
const RegisterPage = () => import('../pages/RegisterPage.vue')
const BookRepoPage = () => import('../pages/BookRepoPage.vue')
const DashboardPage = () => import('../pages/DashboardPage.vue')
const GithubAppPage = () => import('../pages/GithubAppPage.vue')
const StyleGuidePage = () => import('../pages/StyleGuidePage.vue')
const AddTemplatePage = () => import('../pages/AddTemplatePage.vue')
const TemplateRepoPage = () => import('../pages/TemplateRepoPage.vue')
const PrivacyPolicyPage = () => import('../pages/PrivacyPolicyPage.vue')
const TermsOfServicePage = () => import('../pages/TermsOfServicePage.vue')
const PdfJobsPage = () => import('../pages/PdfJobsPage.vue')
const BookChapterPage = () => import('../pages/BookChapterPage.vue')
const PendingUsersPage = () => import('../pages/PendingUsersPage.vue')
const EventsPage = () => import('../pages/EventsPage.vue')
const BusinessMetricsPage = () => import('../pages/BusinessMetricsPage.vue')
const PerformanceMetricsPage = () => import('../pages/PerformanceMetricsPage.vue')
const UserExperiencePage = () => import('../pages/UserExperiencePage.vue')
const DevelopmentTasksPage = () => import('../pages/DevelopmentTasksPage.vue')
const AdminSettingsPage = () => import('../pages/AdminSettingsPage.vue')

const routes: RouteRecordRaw[] = [
    { path: '/', component: HomePage },
    { path: '/about', component: AboutPage },
    { path: '/style-guide', component: StyleGuidePage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/privacy-policy', component: PrivacyPolicyPage },
    { path: '/terms-of-service', component: TermsOfServicePage },
    { path: '/contact', component: ContactPage },
    { path: '/signin', name: 'SignIn', component: SignInPage },
    { path: '/register', name: 'Register', component: RegisterPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/users', component: UsersPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/profile', component: ProfilePage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/logs', component: LogsPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/events', component: EventsPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/business-metrics', component: BusinessMetricsPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/performance-metrics', component: PerformanceMetricsPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/user-experience', component: UserExperiencePage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/pending-users', component: PendingUsersPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/pdf-jobs', component: PdfJobsPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/development-tasks', component: DevelopmentTasksPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/admin-settings', component: AdminSettingsPage, meta: { requiresAuth: true, requiresSuperUser: true } },

    { path: '/dashboard', name: 'Dashboard', component: DashboardPage, meta: { requiresAuth: true } },
    { path: '/book/new', name: 'AddBook', component: AddBookPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/book-repo/:id', name: 'BookRepo', component: BookRepoPage, meta: { requiresAuth: true } },
    { path: '/book-repo/:id/chapter/:n', name: 'BookChapter', component: BookChapterPage, meta: { requiresAuth: true } },
    { path: '/template/new', name: 'AddTemplate', component: AddTemplatePage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/template-repo/:id', name: 'TemplateRepo', component: TemplateRepoPage, meta: { requiresAuth: true, requiresSuperUser: true } },
    { path: '/github-app/:id', component: GithubAppPage, meta: { requiresAuth: true, requiresSuperUser: true } },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

// Authentication guard with redirect preservation
router.beforeEach((to, from, next) => {
    console.log(`🔐 Router guard: ${from.path} -> ${to.path} (requiresAuth: ${to.meta.requiresAuth}, isSignedIn: ${isSignedIn()})`)
    
    if ((to.meta.requiresAuth || to.meta.requiresSuperUser) && !isSignedIn()) {
        console.log(`🔐 Auth required for ${to.fullPath}, saving intended path`)
        saveIntendedPath(to.fullPath)
        next({ name: 'SignIn' })
        return
    }

    if (to.meta.requiresSuperUser && !isCurrentUserSuperUser()) {
        console.log(`🔐 Super user required for ${to.fullPath}, redirecting to dashboard`)
        next({ name: 'Dashboard' })
        return
    }

    next()
})

export default router
